import { Component } from '@angular/core';
import { routeAlias } from '../../../../routesalias';
import { closeLocalStorage } from '../../../utils/helpers';
import { OngletlayoutComponent } from "../../../components/layouts/ongletlayout/ongletlayout.component";
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-administration',
  imports: [OngletlayoutComponent, RouterOutlet],
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.css'
})
export class AdministrationLayout {
  tableLinkForParameters = [
    {
      text: "Agent",
      link: routeAlias.administration.agent.home,
    },
    {
      text: "Utilisateurs",
      link: routeAlias.administration.utilisateur.home,
    },
    { text: "Synchronisation", link: routeAlias.administration.synchronisation.home },
  ]

  onCloseLocalStorage(): void {
    closeLocalStorage();
  }
}
